<template>
  <div class="home-container">
    <!-- 背景层 -->
    <div class="background-layer">
      <img src="@/assets/img/img23.png" class="bg-img" />
      <div class="bg-overlay"></div>
    </div>

    <!-- 内容层 -->
    <div class="content-layer">
      <!-- 顶部用户信息 -->
      <div class="user-header">
        <div class="user-info">
          <div class="avatar-wrapper">
            <img :src="avatar" class="avatar" />
          </div>
          <div class="user-details">
            <div class="mobile-number">{{ nikename }}</div>
            <div class="user-welcome">欢迎回来</div>
          </div>
        </div>
        <div class="header-actions">
          <i class="el-icon-s-tools settings-icon" @click="goSettings"></i>
        </div>
      </div>

      <!-- 功能导航 -->
      <div class="function-nav">
        <div class="nav-title">功能导航</div>
        <div class="nav-grid">
          <!-- 一级菜单 -->
          <div
            class="nav-item"
            v-for="(item, index) in navList"
            v-if="checkFirstMenuPermission(item.type)"
            :key="index"
            :class="{
              active: activeNav === item.type,
              'has-children': item.children,
            }"
          >
            <!-- 一级菜单点击区域 -->
            <div class="nav-main" @click="handleNavClick(item)">
              <div class="nav-icon-wrapper">
                <i :class="item.icon" class="nav-icon"></i>
              </div>
              <div class="nav-text">{{ item.title }}</div>
              <!-- 有子菜单时显示展开/收起箭头 -->
              <div v-if="item.children" class="nav-toggle">
                <i
                  class="el-icon-arrow-down"
                  :class="{ expanded: expandedNav === item.type }"
                ></i>
              </div>
              <!-- 无子菜单时显示原箭头 -->
              <img v-else src="@/assets/img/img18.png" class="nav-arrow" />
            </div>

            <!-- 二级菜单 -->
            <div
              v-if="item.children && expandedNav === item.type"
              class="nav-children"
            >
              <div
                class="nav-child-item"
                v-for="(child, idx) in item.children"
                v-if="checkSecondMenuPermission(child.type)"
                :key="idx"
                @click.stop="handleChildNavClick(child)"
              >
                <span>{{ child.title }}</span>
                <img src="@/assets/img/img18.png" class="nav-arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 消息组件 -->
    <message :title="messageTitle" ref="messageRef"></message>
  </div>
</template>

<script>
import message from "@/components/message.vue";
import { authFirstMenu,authSecondMenu } from '@/utils/auth'
export default {
  components: { message },
  data() {
    return {
      nikename: JSON.parse(
        localStorage.getItem("userInfo") || '{"nickName":"默认用户"}',
      ).nickName,
      avatar:
        JSON.parse(localStorage.getItem("userInfo")).avatar ||
        require("@/assets/img/img24.png"),
      messageTitle: "",
      activeNav: null,
      expandedNav: null, // 控制二级菜单展开/收起
      navList: [
        {
          type: "style",
          title: "款号",
          icon: "el-icon-s-goods",
          badge: "2",
          path: "/style",
        },
        {
          type: "order",
          title: "订单管理",
          icon: "el-icon-s-order",
          badge: "2",
          children: [
            // 添加二级菜单配置
            {
              type: "order",
              title: "订单列表",
              path: "/orderlist?type=order",
            },
            {
              type: "orderList",
              title: "款号查询",
              path: "/orderlist?type=orderList",
            },
          ],
        },
        {
          type: "sales",
          title: "销售运营",
          icon: "el-icon-user-solid",
          badge: "2",
          children: [
            // 添加二级菜单配置
            {
              type: "myShipment",
              title: "我的出货清单",
              path: "/shipment?type=my",
            },
          ],
        },
        {
          type: "printing",
          title: "印花生产",
          icon: "el-icon-s-check",
          badge: "2",
          children: [
            {
              type: "print",
              title: "打印室",
              path: "/orderlist?type=print",
            },
            {
              type: "machines",
              title: "大机",
              path: "/orderlist?type=machines",
            },
            {
              type: "laser",
              title: "激光",
              path: "/orderlist?type=laser",
            },
          ],
        },
        {
          type: "finance",
          title: "印花财务",
          icon: "el-icon-s-unfold",
          badge: "5",
          children: [
            // 添加二级菜单配置
            {
              type: "laserList",
              title: "我的激光清单",
              path: "/laser",
            },
          ],
        },
        {
          type: "clothing",
          title: "制衣管理",
          icon: "el-icon-s-tools",
          badge: "2",
          children: [
            {
              type: "clothingOrder",
              title: "订单列表",
              path: "/orderlist?type=clothingOrder",
            },
            {
              type: "producing",
              title: "生产中",
              path: "/orderlist?type=producing",
            },
            {
              type: "shipment",
              title: "出货清单",
              path: "/shipment?type=shipment",
            },
          ],
        },
        {
          type: "manage",
          title: "制衣生产",
          icon: "el-icon-video-camera-solid",
          badge: "2",
          children: [
            {
              type: "deptProducing",
              title: "生产中",
              path: "/orderlist?type=deptProducing",
            },
            {
              type: "deptShipment",
              title: "出货清单",
              path: "/shipment?type=deptShipment",
            },
          ],
        },
        {
          type: "clothingFinance",
          title: "制衣财务",
          icon: "el-icon-s-claim",
          badge: "3",
          children: [
            {
              type: "settleShipment",
              title: "结算清单",
              path: "/settleShipment?type=settleShipment",
            },
            {
              type: "settleDeptShipment",
              title: "我的结算清单",
              path: "/settleShipment?type=settleDeptShipment",
            },
            {
              type: "process",
              title: "车缝清单",
              path: "/processing?type=process",
            },
            {
              type: "myProcess",
              title: "我的车缝清单",
              path: "/processing?type=myProcess",
            },
          ],
        },
      ],
    };
  },

  methods: {
    // 检查一级菜单权限
    checkFirstMenuPermission(menuType) {
      return authFirstMenu(menuType);
    },
    // 检查二级菜单权限
    checkSecondMenuPermission(menuType) {
      return authSecondMenu(menuType);
    },
    goSettings() {
      console.log("跳转到设置页面");
      this.$router.push({
        path: "/info",
      });
    },
    // 处理一级菜单点击
    handleNavClick(nav) {
      this.activeNav = nav.type;
      // 找到当前菜单是否有子菜单
      const currentItem = this.navList.find((item) => item.type === nav.type);
      if (currentItem?.children) {
        // 有子菜单则切换展开/收起状态
        this.expandedNav = this.expandedNav === nav.type ? null : nav.type;
      } else {
        // 无子菜单则直接跳转
        this.$router.push({ path: nav.path });
      }
    },
    // 处理二级菜单点击
    handleChildNavClick(item) {
      if (item.path) {
        this.$router.push({
          path: item.path,
        });
        // 跳转后收起二级菜单
        this.expandedNav = null;
      }
    },
    handleQuickAction(type) {
      console.log("快捷操作:", type);
      // 处理快捷操作
    },
  },
};
</script>

<style lang="scss" scoped>
.home-container {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 背景层 */
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  .bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.95) 60%
    );
  }
}

/* 内容层 */
.content-layer {
  position: relative;
  z-index: 2;
  padding: 20px;
  padding-top: 60px;
  /* 为状态栏留出空间 */
}

/* 顶部用户信息 */
.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  animation: slideDown 0.6s ease-out;

  .user-info {
    display: flex;
    align-items: center;

    .avatar-wrapper {
      position: relative;
      margin-right: 15px;

      .avatar {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        border: 3px solid rgba(255, 255, 255, 0.8);
        box-shadow: 0 8px 20px rgba(255, 129, 61, 0.25);
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.05);
          box-shadow: 0 10px 25px rgba(255, 129, 61, 0.35);
        }
      }
    }

    .user-details {
      .mobile-number {
        font-size: 22px;
        font-weight: 700;
        color: #303133;
        margin-bottom: 5px;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      }

      .user-welcome {
        font-size: 14px;
        color: #666;
        opacity: 0.8;
      }
    }
  }

  .header-actions {
    .badge-icon {
      ::v-deep .el-badge__content.is-fixed {
        top: 2px;
        right: 2px;
      }
    }

    .settings-icon {
      font-size: 24px;
      color: #ff813d;
      padding: 10px;
      background: rgba(255, 255, 255, 0.9);
      border-radius: 50%;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(255, 129, 61, 0.2);

      &:hover {
        transform: rotate(30deg);
        background: white;
        box-shadow: 0 6px 16px rgba(255, 129, 61, 0.3);
      }

      &:active {
        transform: rotate(30deg) scale(0.95);
      }
    }
  }
}

/* 功能导航 */
.function-nav {
  margin-bottom: 30px;
  animation: slideUp 0.6s ease-out 0.2s both;

  .nav-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;
    padding-left: 5px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 16px;
      background: #ff813d;
      border-radius: 2px;
    }
  }

  .nav-grid {
    display: grid;
    // grid-template-columns: repeat(2, 1fr);
    grid-template-columns: 1fr; // 改为单列
    gap: 15px;

    .nav-item {
      background: white;
      border-radius: 16px;
      padding: 20px 18px;
      position: relative;
      box-shadow: 0 6px 20px rgba(102, 25, 17, 0.08);
      transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
      cursor: pointer;
      border: 1px solid transparent;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, #ff813d, #ffb347);
        opacity: 0;
        transition: opacity 0.3s ease;
      }

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 30px rgba(102, 25, 17, 0.15);
        border-color: rgba(255, 129, 61, 0.2);

        &::before {
          opacity: 1;
        }

        .nav-icon {
          transform: scale(1.1);
        }

        .nav-arrow {
          transform: translateX(3px);
        }
      }

      &:active {
        transform: translateY(-2px) scale(0.98);
      }

      &.active {
        background: linear-gradient(135deg, #fff5f0, #ffffff);
        border-color: rgba(255, 129, 61, 0.3);

        &::before {
          opacity: 1;
        }
      }

      // 一级菜单主区域
      .nav-main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
      }

      .nav-icon-wrapper {
        position: relative;
        margin-right: 12px;

        .nav-icon {
          font-size: 24px;
          color: #ff813d;
          transition: transform 0.3s ease;
        }
      }

      .nav-text {
        flex: 1;
        font-size: 16px;
        font-weight: 500;
        color: #303133;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      // 展开/收起箭头
      .nav-toggle {
        font-size: 14px;
        color: #ff813d;
        transition: transform 0.3s ease;

        .expanded {
          transform: rotate(180deg);
        }
      }

      .nav-arrow {
        width: 8px;
        height: 14px;
        transition: transform 0.3s ease;
        margin-left: 10px;
      }

      // 二级菜单样式
      .nav-children {
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid #f5f5f5;

        .nav-child-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          font-size: 14px;
          color: #303133;

          &:hover {
            color: #ff813d;

            .nav-arrow {
              transform: translateX(3px);
            }
          }
        }
      }
    }
  }
}

/* 快捷操作 */
.quick-actions {
  margin-bottom: 30px;
  animation: slideUp 0.6s ease-out 0.4s both;

  .quick-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;
    padding-left: 5px;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 16px;
      background: #4a90e2;
      border-radius: 2px;
    }
  }

  .action-buttons {
    display: flex;
    justify-content: space-between;
    gap: 15px;

    .action-btn {
      flex: 1;
      background: white;
      border-radius: 14px;
      padding: 18px 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 20px rgba(74, 144, 226, 0.1);
      transition: all 0.3s ease;
      cursor: pointer;
      border: 1px solid transparent;

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 10px 25px rgba(74, 144, 226, 0.15);
        border-color: rgba(74, 144, 226, 0.2);

        .action-icon {
          transform: scale(1.1);
        }
      }

      &:active {
        transform: translateY(-1px) scale(0.98);
      }

      .action-icon {
        font-size: 26px;
        color: #4a90e2;
        margin-bottom: 10px;
        transition: transform 0.3s ease;
      }

      .action-text {
        font-size: 14px;
        font-weight: 500;
        color: #303133;
        text-align: center;
      }
    }
  }
}

/* 底部提示 */
.bottom-tips {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  z-index: 3;
  animation: fadeIn 0.8s ease-out 0.6s both;

  .tips-content {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 50px;
    padding: 14px 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.3);

    .tips-icon {
      font-size: 18px;
      color: #ff813d;
      margin-right: 10px;
    }

    .highlight {
      color: #ff4757;
      font-weight: 700;
      margin: 0 4px;
    }

    span {
      font-size: 14px;
      color: #303133;
      font-weight: 500;
    }
  }
}

/* 动画定义 */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
  }

  70% {
    box-shadow: 0 0 0 6px rgba(255, 71, 87, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
  }
}

@keyframes badgePulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* 响应式调整 */
@media (max-width: 360px) {
  .content-layer {
    padding: 15px;
    padding-top: 50px;
  }

  .nav-grid {
    grid-template-columns: 1fr !important;
    gap: 12px !important;
  }

  .action-buttons {
    flex-direction: column;
    gap: 12px !important;
  }

  .user-header .user-details .mobile-number {
    font-size: 20px;
  }

  .avatar {
    width: 60px !important;
    height: 60px !important;
  }
}

@media (min-width: 768px) {
  .content-layer {
    max-width: 500px;
    margin: 0 auto;
  }

  .bottom-tips {
    max-width: 500px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
